import {InjectionToken} from '@angular/core';
import {AddBusinessFormData} from './add-business-form-data';

export const BUSINESS_FORM = new InjectionToken<AddBusinessFormData>('BUSINESS_FORM');
